import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fournineseaterbusonrent() {



  const cardData =
  {
    keyword: '49 Seater Bus on Rent in Pune',
    heading: 'Sanavi Travels: 49 Seater Bus on Rent in Pune',
    headingDescription: 'Sanavi Travels offers reliable 49 Seater Bus on Rent in Pune, providing safe, comfortable, and spacious transportation for large groups, corporate events, school trips, weddings, and outstation travel. Our fleet of well-maintained AC and non-AC 49-seater buses ensures ample seating, smooth rides, and a hassle-free journey for all passengers. With professional drivers, flexible full-day and outstation rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Pune including Hinjewadi, Baner, Wakad, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, making us a trusted choice for large-group transportation. Choose Sanavi Travels for trusted 49 seater bus rental services in Pune, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s iconic 18th-century fort built by the Peshwas, featuring massive stone walls, grand gateways like Delhi Darwaza, and spacious courtyards. Though partly destroyed by fire, it stands as a symbol of Maratha heritage and valor. The evening light-and-sound show narrates Pune’s royal history."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a historic monument tied to India’s freedom movement, where Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned. It now houses a museum displaying Gandhi’s personal artifacts and documents amidst serene gardens, making it a significant heritage site."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The idol, adorned with gold ornaments, draws thousands of devotees daily. Ganesh Chaturthi sees grand celebrations, music, and cultural events, highlighting its spiritual and social significance."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, situated on a hilltop near Pune, is famous for the 1670 battle where Tanaji Malusare sacrificed his life for Shivaji Maharaj. Visitors can trek or drive to explore the fort, enjoy scenic Sahyadri views, and savor local delicacies like pithla-bhakri."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from basalt rock, it features monolithic pillars and a serene sanctum. Despite its urban location, it offers peace, meditation, and a glimpse into ancient craftsmanship."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts including traditional ornaments, musical instruments, and household antiques. The recreated Mastani Mahal is a highlight, offering cultural and historical insights into India’s heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views after climbing 103 steps. The hilltop temple complex, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era and includes smaller shrines and a museum."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global center for meditation, wellness therapies, and mindfulness. Spread across landscaped gardens, it attracts visitors seeking relaxation, rejuvenation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With arched bridges, water streams, and manicured lawns, it is perfect for morning walks, family outings, and photography."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot near Pune. Surrounded by hills, it offers scenic views, especially during monsoon. Visitors enjoy picnics, sunset views, and local snacks, making it a favorite weekend destination."
  }
]
,




"services": [
  {
    "name": "49 Seater Bus on Rent in Pune",
    "description": "49 Seater Bus on Rent in Pune provides large, spacious buses ideal for group travel, long-distance trips, corporate events, weddings, and school or college excursions. Equipped with air-conditioning, comfortable reclining seats, and ample luggage space, these buses ensure a relaxed and enjoyable journey. Professional chauffeurs manage routes, traffic, and schedules, allowing passengers to focus on enjoying the trip. Suitable for day trips, multi-city tours, and special events, the service emphasizes safety, punctuality, and convenience. Flexible pickup and drop-off points and customizable itineraries make it perfect for large groups traveling within Pune or to nearby cities."
  },
  {
    "name": "49 Seater Bus Hire Pune",
    "description": "49 Seater Bus Hire Pune offers organized bus rental services for schools, colleges, corporate groups, family gatherings, and social events. The buses are fully air-conditioned, spacious, and equipped with comfortable seating and storage for luggage. Experienced chauffeurs ensure safe, timely, and smooth travel, while the service supports flexible schedules, multiple stops, and customizable routes. Ideal for group excursions, city tours, and outstation trips, this service combines reliability, comfort, and convenience for large-scale travel needs."
  },
  {
    "name": "AC 49 Seater Bus Pune",
    "description": "AC 49 Seater Bus Pune ensures a comfortable and refreshing journey for large groups with fully air-conditioned interiors, reclining seats, and wide legroom. Designed for family trips, school outings, corporate travel, and wedding events, the buses prioritize passenger comfort and safety. Professional drivers handle navigation, traffic, and route planning, guaranteeing timely arrivals and a stress-free journey. Flexible booking options and multi-stop itineraries make it perfect for both short city trips and long-distance travel from Pune."
  },
  {
    "name": "Luxury 49 Seater Bus Pune",
    "description": "Luxury 49 Seater Bus Pune provides premium, high-comfort buses with elegant interiors, advanced seating, air-conditioning, and entertainment facilities for large groups. Ideal for weddings, corporate events, VIP travel, and tourist excursions, this service focuses on delivering a superior travel experience. Professional chauffeurs manage driving, traffic, and schedules efficiently, ensuring safety and punctuality. With flexible pickup and drop-off points and customizable travel plans, this service is perfect for passengers seeking luxury, convenience, and reliability for group journeys."
  },
  {
    "name": "Wedding 49 Seater Bus Pune",
    "description": "Wedding 49 Seater Bus Pune specializes in transporting large groups of guests to wedding venues, ceremonies, and receptions in comfort and style. Buses are air-conditioned, spacious, and equipped with comfortable seating and luggage space for personal items and gifts. Experienced chauffeurs ensure timely arrivals, smooth driving, and stress-free coordination of multiple stops. This service is ideal for family weddings, destination weddings, and multi-location celebrations, offering flexibility, safety, and convenience for guests traveling together."
  },
  {
    "name": "Corporate 49 Seater Bus Pune",
    "description": "Corporate 49 Seater Bus Pune provides organized transportation for corporate events, team outings, conferences, and employee transfers. The buses feature air-conditioning, spacious seating, and ample luggage capacity. Professional chauffeurs manage navigation, traffic, and schedules, ensuring timely and reliable transport for employees. Flexible itineraries, multi-stop trips, and convenient booking options make this service suitable for daily corporate travel, business retreats, and long-distance corporate trips from Pune."
  },
  {
    "name": "Outstation 49 Seater Bus Pune",
    "description": "Outstation 49 Seater Bus Pune is ideal for long-distance travel and intercity trips with large groups. Buses are air-conditioned, spacious, and equipped with reclining seats, comfortable interiors, and luggage storage. Experienced chauffeurs handle highways, route planning, and travel logistics, ensuring a smooth and safe journey. Perfect for school trips, corporate tours, family vacations, and tourist excursions, this service provides flexible routes, scheduled stops, and reliable transport for groups traveling outside Pune."
  },
  {
    "name": "Affordable 49 Seater Bus Pune",
    "description": "Affordable 49 Seater Bus Pune offers budget-friendly rental options for large groups without compromising on comfort or safety. The buses are well-maintained, air-conditioned, and equipped with spacious seating and luggage space. Professional drivers ensure timely pickups, smooth driving, and safe arrivals. Ideal for families, schools, corporate groups, and social events, this service combines cost-efficiency, reliability, and convenience for large group travel within Pune and nearby destinations."
  },
  {
    "name": "Chauffeur Driven 49 Seater Bus",
    "description": "Chauffeur Driven 49 Seater Bus provides a stress-free and comfortable journey for large groups, with professional drivers handling navigation, traffic, and scheduling. The buses are spacious, air-conditioned, and equipped with comfortable seats and luggage storage. Suitable for weddings, corporate events, school trips, and tourist excursions, this service ensures a smooth, safe, and reliable travel experience. Flexible itineraries and multi-stop options allow passengers to plan trips according to their needs and preferences."
  },
  {
    "name": "Best 49 Seater Bus Pune",
    "description": "Best 49 Seater Bus Pune offers premium, well-maintained buses with air-conditioning, spacious seating, and ample luggage space for large groups. Designed for weddings, corporate events, school trips, and leisure travel, the service focuses on safety, comfort, and reliability. Experienced chauffeurs handle route planning, traffic, and scheduling efficiently, providing a stress-free travel experience. Flexible pickup, drop-off, and itinerary options make it ideal for long-distance journeys, day trips, or multi-stop excursions from Pune."
  },
  {
    "name": "Pune Bus Booking Service",
    "description": "Pune Bus Booking Service allows customers to easily reserve 49-seater buses online for weddings, corporate events, school trips, and group travel. Users can select pickup and drop locations, travel dates, bus types, and itineraries with instant confirmation. Fully air-conditioned buses with professional chauffeurs ensure a comfortable, safe, and reliable journey. This service is suitable for families, friends, corporate teams, and tourist groups seeking convenient and hassle-free large group travel in and around Pune."
  },
  {
    "name": "Tourist 49 Seater Bus Pune",
    "description": "Tourist 49 Seater Bus Pune provides organized bus transport for sightseeing, heritage tours, and leisure trips around Pune and nearby destinations. Buses are air-conditioned, spacious, and equipped with comfortable seating and luggage space. Experienced chauffeurs manage routes, traffic, and stops efficiently, ensuring a smooth and enjoyable travel experience. Perfect for family trips, school excursions, corporate leisure tours, and group sightseeing, this service offers convenience, safety, and comfort for all passengers."
  },
  {
    "name": "Event Bus Rental Pune",
    "description": "Event Bus Rental Pune offers reliable transportation for weddings, corporate gatherings, parties, and social events. The buses are air-conditioned, spacious, and provide comfortable seating and luggage storage for guests. Professional drivers ensure punctual pickups, smooth driving, and coordinated travel across multiple locations. Suitable for large groups attending weddings, conferences, or celebrations, this service emphasizes safety, convenience, and comfort, allowing passengers to enjoy the event without travel-related stress."
  },
  {
    "name": "Family Trip Bus Pune",
    "description": "Family Trip Bus Pune is ideal for large families planning outings, vacations, or special trips. The 49-seater buses provide air-conditioning, comfortable seating, and ample luggage space, ensuring a relaxed and enjoyable journey. Experienced chauffeurs manage routes, traffic, and schedules, allowing families to focus on spending quality time together. Flexible itineraries, multi-stop trips, and pick-up/drop-off options make this service suitable for day trips, weekend getaways, or long-distance travel from Pune."
  },
  {
    "name": "Group Travel Bus Pune",
    "description": "Group Travel Bus Pune specializes in transporting large groups for school trips, corporate events, weddings, and leisure tours. The buses are spacious, air-conditioned, and equipped with comfortable seating and storage for luggage. Professional chauffeurs ensure safe, smooth, and timely travel. Flexible scheduling, multi-stop itineraries, and convenient pickup/drop-off locations provide a seamless travel experience for groups of all sizes. Perfect for day trips, weekend getaways, or long-distance excursions in and around Pune."
  }
],
"tableData": [
  ["49 Seater Bus on Rent in Pune", "49 Seater Bus Hire Pune"],
  ["AC 49 Seater Bus Pune", "Luxury 49 Seater Bus Pune"],
  ["Wedding 49 Seater Bus Pune", "Corporate 49 Seater Bus Pune"],
  ["Outstation 49 Seater Bus Pune", "Affordable 49 Seater Bus Pune"],
  ["Chauffeur Driven 49 Seater Bus", "Best 49 Seater Bus Pune"],
  ["Pune Bus Booking Service", "Tourist 49 Seater Bus Pune"],
  ["Event Bus Rental Pune", "Family Trip Bus Pune"],
  ["Group Travel Bus Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "49 Seater Bus on Rent in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers 49-seater buses on rent in Pune, perfect for large group trips, corporate events, school excursions, and wedding transportation."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and regularly serviced 49-seater buses for a comfortable and enjoyable journey in Pune."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with Pune routes, ensuring safe and timely transportation for large groups."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for 49-seater bus rentals, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route planning, and any last-minute changes for your 49-seater bus rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized rental packages based on your group’s schedule and travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All 49-seater buses are thoroughly cleaned and sanitized before each trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for 49-seater bus rentals in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide 49-seater buses on rent in Pune?',
    answer: 'Yes, Sanavi Travels offers 49-seater buses for large group trips, corporate events, school excursions, and wedding transportation in Pune.'
  },
  {
    question: 'How can I book a 49-seater bus in Pune?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Are the 49-seater buses well-maintained and air-conditioned?',
    answer: 'Yes, all our 49-seater buses are clean, air-conditioned, and regularly serviced for a comfortable travel experience.'
  },
  {
    question: 'Are drivers experienced with Pune routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Pune routes to ensure safe and timely transportation.'
  },
  {
    question: 'Can I rent the 49-seater bus for a few hours or a full day?',
    answer: 'Absolutely. We offer hourly, half-day, full-day, and custom packages to meet your travel requirements.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all 49-seater buses are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'Is customer support available during the rental?',
    answer: 'Yes, our 24x7 customer support team is available throughout your 49-seater bus rental.'
  },
  {
    question: 'What payment options are available for 49-seater bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is punctual service guaranteed for 49-seater bus rentals?',
    answer: 'Yes, Sanavi Travels ensures on-time pickups and reliable service for all 49-seater bus bookings in Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Deshmukh',
    feedback: 'Booked a 49-seater bus for our corporate trip. Spacious, clean, and the driver was very professional.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Excellent 49-seater bus rental service. Comfortable ride, on-time pickup, and very helpful staff.',
    rating: 5
  }
];


































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "49 Seater Bus on Rent in Pune - Sanavi Travels",
  "description": "Hire 49 seater buses in Pune with Sanavi Travels. AC and luxury buses ideal for weddings, corporate events, outstation trips, family travel, group tours, events, and chauffeur-driven comfortable journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};






  return (
    <div>
<Helmet>
  <title>
    49 Seater Bus on Rent in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC and luxury 49 seater buses in Pune with Sanavi Travels. Perfect for weddings, corporate events, outstation trips, family travel, group tours, events, and safe chauffeur-driven journeys."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/78.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fournineseaterbusonrent;